import Rest from "@/services/Rest";
import qs from 'qs';

export default class ProcedureModelService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/procedureModels'

  search(parameters = {}) {
    return this.get(`/`, {
      params: parameters,
      paramsSerializer: params => { // Dobbiamo fare lo stringify perchè grails non capisce gli array non encodati
        return qs.stringify(params, { arrayFormat: 'repeat'})
      }
    })
  }
}
